import { Injectable } from '@angular/core';
import { collection, doc, Firestore, getDoc, getDocs, orderBy, query } from '@angular/fire/firestore';
import { Report } from '../models/report';
import { AreaItem } from '../models/area-item';

@Injectable()
export class ReportService {
  constructor(
    private firestore: Firestore
  ) {}

  async readByIdAsync(sectionId: string, reportId: string): Promise<Report> {
    const reportDocRef = doc(this.firestore, `sections/${sectionId}/templates/${reportId}`);
    const reportSnapshot = await getDoc(reportDocRef);

    if (reportSnapshot.exists()) {
      return reportSnapshot.data() as Report;
    } else {
      throw new Error('Report not found');
    }
  }

  async readItemsByReportIdAsync(sectionId: string, reportId: string, areaId: string): Promise<{ id: string, data: AreaItem }[]> {
    // This method should return an observable of items by reportId
    // It can be implemented to fetch items from a Firestore collection
    // For example:
    const itemsCollectionRef = collection(this.firestore, `sections/${sectionId}/templates/${reportId}/areas/${areaId}/items`);
    const itemsQuery = query(itemsCollectionRef, orderBy('date', 'asc'));

    const snapshot = await getDocs(itemsQuery);
    return snapshot.docs.map(doc => {
      return { id: doc.id, data: doc.data() as AreaItem };
    });
  }
}
